<template>
  <div>
    <v-card outlined class="overflow-y-auto mt-0 pt-0" max-height="800">
      <v-list>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title><strong> {{ paciente.nomePaciente }} </strong> </v-list-item-title>
              <v-list-item-subtitle v-if="!paciente.cpf">CPF: <strong> ---.--
              </strong></v-list-item-subtitle>

              <v-list-item-subtitle v-else>CPF: <strong class="indigo--text">{{ paciente.cpf.slice(0, 3) +
                '.' + paciente.cpf.slice(3) + '*.***-**' }} </strong></v-list-item-subtitle>

              <!-- <v-list-item-subtitle>Mãe: <strong>{{ paciente.nomeMae || '-----' }}</strong></v-list-item-subtitle> -->
              <v-list-item-subtitle>Data de Nascimento: <strong class="green--text">{{
                paciente.dataNascimento ? formatarData(paciente.dataNascimento) : '-----'
              }}</strong></v-list-item-subtitle>
              <v-divider />
            </v-list-item-content>
          </v-list-item>

        </v-list-item-group>

      </v-list>
      <!-- {{ solicitacoesExames }} -->
        <v-card flat class="pa-2" v-if="solicitacoesExames.length > 0 && isSelectExame">
          <v-data-table hide-default-footer height="400" :headers="headers" :items="solicitacoesExames"
            class="elevation-1" :items-per-page="100">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>
                  <div class="green--text ml-2" v-show="!loadMoney">{{ orcamentoExames }}</div>
                </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer />
                <v-btn :loading="loadMoney" outlined @click="gerarVoucher(2)" class="mr-2" color="blue">
                  <v-icon left>
                    payments
                  </v-icon>
                  <span>Gerar voucher</span>
                  </v-btn>
                <!-- <v-autocomplete class="mt-5" @change="searchExame = ''" v-model="exame1" :items="items"
                  :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected
                  item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame"
                  prepend-icon="mdi-database-search" return-object></v-autocomplete> -->
                <!-- <v-spacer></v-spacer> -->
                <!-- <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog> -->
              </v-toolbar>
            </template>
            <template v-slot:item.valor="{ item }">
              <strong v-if="item.valor" class="green--text">{{ item.valor }}</strong>
              <v-icon v-else color="#E17833">warning</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn :loading="loadMoney" icon @click="deleteItem(item)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>

          </v-data-table>
          <v-card-actions>
            <v-spacer />
            <!-- Imprimir orçamento -->
            <!-- <v-btn :loading="loadMoney" outlined @click="gerarOrcamento(1)" class="mr-2" color="green">
            <v-icon left>
                payments
            </v-icon>
            <span>Gerar Orçamento</span>
        </v-btn> -->
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :loading="loadSolicitacao"
                  :disabled="ficha.idSolicitacaoPos != null || loadMoney || alertOrcamento" v-on="on"
                  @click="gerarVoucher(1)" class="mr-2" color="primary">
                  <v-icon left>
                    local_printshop
                  </v-icon>
                  <span>Gerar Voucher</span>
                </v-btn>
              </template>
              <span> Gerar Voucher </span>
            </v-tooltip> -->

          </v-card-actions>
          <v-alert dense color="#E17833" border="left" type="warning" v-show="alertOrcamento">
            <strong>Importante:</strong> <span> Exame de valor inestimável detectado! Por favor, acione o setor de
              faturamento. Além disso, lembre-se de remover o exame sem valor estimado para que possamos gerar um
              voucher
              adequado.</span>
          </v-alert>
          <!-- APAGAR EXAMES-->
          <v-dialog v-model="isDelete" max-width="350" persistent>
            <v-card>
              <v-card-title class="text-h7">
                Tem certeza que quer apagar este exame?
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="isDelete = false">
                  Cancelar
                </v-btn>
                <v-btn color="green darken-1" text @click="isDelete = false, solicitacoesExames.splice(indexExame, 1)">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- <v-alert type="info" v-show="ficha.idSolicitacaoPos != null" text dense :value="true">
            Esse voucher já foi gerado!
          </v-alert> -->
        </v-card>
    </v-card>
    <v-alert dense color="error" border="left" type="error" v-show="erroServicos">
      <strong>Erro:</strong> <span> {{ erroServicos }} </span>
      </v-alert>
  </div>
</template>
<script>
import posAtendimentoService from '../../services/posAtendimento.service'
import atendenteService from '../../services/atendente.service'
import pacienteService from '../../services/paciente.service'

import moment from 'moment'

export default {
  name: 'pacienteSelecionado',
  props: {
    pacienteSelecionado: {
      type: Object,
      required: true
    },
    examesSelecionados: {
      type: Array,
      default: () => []
    },
    idAuxPaciente: {
      type: Number,
      required: true
    },
    isSelectExame: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      paciente: this.pacienteSelecionado,
      loadMoney: false,
      solicitacoesExames: this.examesSelecionados,
      loadSolicitacao: false,
      user: {},
      servicos: [],
      indexExame: null,
      idUnidadeNegocio: null,
      orcamentoExames: 'Orçamento de Exames',
      alertOrcamento: false,
      isDelete: false,
      isLoading: false,
      erroServicos: '',
      idPaciente: this.idAuxPaciente,
      searchExame: '',
      exame1: null,
      headers: [{
        text: 'Nome',
        value: 'apelido'
      },
      {
        text: 'Valor',
        value: 'valor'
      },
      {
        text: '',
        fixedTabs: true,
        value: 'actions'
      }
      ],
      nomeUnidade: 'CMR TESTE',
      codigoFicha: 321,
      prioridadeServico: 1,
      prioridade: false,
      ultimaPrioridadeChamada: 'C',
      ultimoCodigoChamado: 320,
      localPrimeiroAtendimento: 'teste',
      senhaWifi: '123333',
      servicosRetornadosOrdenados: [
        {
          nomeEspecialidade: 'Teste Especialidade'
        },
        {
          nomeEspecialidade: 'Teste Especialidade2'
        }

      ]

    }
  },
  methods: {
    gerarVoucher (tipo) {
      var exames = []
      var solicitacoes = tipo == 2 ? this.solicitacoesExames : []
      solicitacoes.forEach(e => {
        exames.push({
          id: 436
        })
      })

      this.loadSolicitacao = true
      console.log('gerar voucher')
      posAtendimentoService.gerarVoucher({
        exames: 'exames',
        idEmpresa: 1,
        idUnidadeNegocio: 983,
        tipoSolicitacao: 'LABORATORIO',
        idPaciente: this.idPaciente,
        idPrestadorAuxiliar: 2239633,
        idUsuario: 80,
        obs: ''
        /* exames: exames,
        idEmpresa: this.user.idEmpresa,
        idUnidadeNegocio: this.idUnidadeNegocio,
        tipoSolicitacao: tipo == 1 ? 'CLINICA' : 'LABORATORIO',
        idPaciente: this.idPaciente,
        idPrestadorSolicitante: null, // id do medico
        idUsuario: this.user.idUsuario,
        obs: '' */
      }).then(r => {
        console.log('--------' + r.data)
        if (r.status == 200 && !r.data.error) {
          console.log(r.data)
          if (r.data.msg === 'sucesso') {
            // Chama a api para cadastrar a OS ao cpf
            console.log(r.data.idOS)
            this.solicitacoesExames = []
          }

          // this.listaExamesSolicitados = [];
        } else {
          this.loadSolicitacao = false
          this.erroVoucher = r.data.msg
          setTimeout(() => {
            this.erroVoucher = ''
          }, 5000)
        }
      }).finally(() => {
        this.loadSolicitacao = false
      })

      this.cadastrarConsultas()
      // this.gerarCodigoNaMaquina2()
    },

    cadastrarPaciente () {
      // nome, cpf, dataNascimento, idOS, senha
      pacienteService.cadastrarPaciente(this.paciente.nomePaciente, this.paciente.cpfCompleto, this.paciente.dataNascimento, 13, this.senha)
        .then(rsp => {
          console.log('rsp cadastrarPaciente', rsp)
          this.idPaciente = rsp.data.idPaciente
          this.paciente.idPaciente = rsp.data.idPaciente
          this.cadastrarConsultas()
        })
        .catch(err => {
          console.log(err)
        }).finally(() => {
          this.senha = ''
        })
    },

    gerarCodigoNaMaquina2 () {
      var d = new Date()
      var mes = this.converterMes(parseInt(d.getMonth()))
      let tela_impressao = window.open()
      // .document.writeln('&nbsp;&nbsp;Centro Médico dos Remédios'+ '</br>')
      tela_impressao.document.writeln(
        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
          this.nomeUnidade +
          '</br>'
      )
      tela_impressao.document.writeln(
        '-----------------------------------------------------' + '</br>'
      )
      tela_impressao.document.writeln(
        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Senha de Atendimento </br>'
      )
      tela_impressao.document.writeln(
        '-----------------------------------------------------' + '</br>'
      )
      // tela_impressao.document.writeln('&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      if (this.prioridadeServico === 0) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = \'7\'>' +
              'C' +
              this.codigoFicha +
              '</font>  </br>'
        )
      } else if (this.prioridadeServico === 1) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = \'7\'>' +
              'P' +
              this.codigoFicha +
              '</font>  </br>'
        )
      } else if (this.prioridadeServico === 2) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = \'7\'>' +
              'B' +
              this.codigoFicha +
              '</font>  </br>'
        )
      } else if (this.prioridadeServico === 3) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = \'7\'>' +
              'A' +
              this.codigoFicha +
              '</font>  </br>'
        )
      }

      tela_impressao.document.writeln(
        ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <div> - Dirija-se a(o):  &nbsp; <b>' +
          this.localPrimeiroAtendimento +
          '</b> </br>'
      )
      var senha = ''
      switch (this.ultimaPrioridadeChamada) {
        case 0:
          senha = 'C' + this.ultimoCodigoChamado
          break
        case 1:
          senha = 'P' + this.ultimoCodigoChamado
          break
        case 2:
          senha = 'B' + this.ultimoCodigoChamado
          break
        case 3:
          senha = 'A' + this.ultimoCodigoChamado
          break
      }

      tela_impressao.document.writeln(
        ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - Última senha chamada:  &nbsp; <b>' +
          senha +
          '</b> </div> </br>'
      )

      tela_impressao.document.write(
        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' +
          this.solicitacoesExames[0].nome +
          ' </br>'
      )
      if (this.solicitacoesExames.length > 1) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
              this.solicitacoesExames[1].nome +
              '</br>'
        )
      }
      if (this.solicitacoesExames.length > 2) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
              this.solicitacoesExames[2].nome +
              '</br>'
        )
      }
      if (this.solicitacoesExames.length > 3) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
              this.solicitacoesExames[3].nome +
              '</br>'
        )
      }
      if (this.solicitacoesExames.length > 4) {
        tela_impressao.document.writeln(
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
              this.solicitacoesExames[4].nome +
              '</br>'
        )
      }

      tela_impressao.document.write(
        '</b> <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Obrigado pela preferência <br/></p>'
      )
      tela_impressao.document.write(
        '<h5>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp' +
          d.getDate() +
          ' de ' +
          mes +
          ' de ' +
          d.getFullYear() +
          '  ' +
          d.getHours() +
          ':' +
          d.getMinutes() +
          ':' +
          d.getSeconds() +
          '</h5></br>'
      )

      var textoWifi = ''
      if (
        this.user.idUnidade == 1 ||
        this.user.idUnidade == 20 ||
        this.user.idUnidade == 295 ||
        this.user.idUnidade == 133 ||
        this.user.idUnidade == 55
      ) {
        textoWifi = '<div>Conecte na rede CM WiFi. </div>' +
              '<div>Usuário: <b>' + this.senhaWifi + '</b></div>' +
              '<div>Senha: <b>' + this.senhaWifi + '</b></div>'
      }
      tela_impressao.document.write(
        textoWifi
      )
      tela_impressao.window.print()
      tela_impressao.window.close()
      this.senha = senha
      this.cadastrarPaciente()
    },

    retornarServicos () {
      atendenteService.atendente
        .retornarServico()
        .then(rsp => {
          if (rsp.data.length) {}
          console.log('rsp retornarServicos', rsp)
          let data = rsp.data
          console.log(data)
          this.servicos = data
        })
        .catch(err => {
          console.log(err)
        })
    },

    cadastrarConsultas () {
      let servicosFiltrados = [] // Passo 1

      this.servicos.forEach(servico => { // Passo 2
        const temExameCorrespondente = this.solicitacoesExames.some(exame => exame.idServico === servico.idServico) // Passo 3
        if (temExameCorrespondente) { // Passo 4
          servicosFiltrados.push(servico) // Adiciona o serviço à lista filtrada
        }
      })
      if (servicosFiltrados.length > 0) { // Passo 5
        // console.log('Nenhum serviço encontrado')
        for (let index = 0; index < servicosFiltrados.length; index++) {
          const element = servicosFiltrados[index]
          let upperCase = element.nomeEspecialidade.toUpperCase()
          if (upperCase == 'LABORATÓRIO' || upperCase == 'LABORATORIO') {
            let servicoAux = element
            servicosFiltrados.splice(index, 1)
            servicosFiltrados.unshift(servicoAux)
          }
        }
        console.log('colocand laboratorio na frente...')
        console.log(servicosFiltrados)

        console.log('em cadastrarConsultas...')
        console.log(this.user.idUnidade)
        atendenteService.atendente
          .cadastrarConsultas(servicosFiltrados, this.prioridade)
          .then(rsp => {
            console.log('rsp cadastrar consultas', rsp)
            this.codigoFicha = rsp.data[0].codigo
            this.ultimoCodigoChamado = rsp.data[0].ultimoCodigoChamado
            this.ultimaPrioridadeChamada = rsp.data[0].ultimaPrioridadeChamada
            this.prioridadeServico = rsp.data[0].prioridade
            this.localPrimeiroAtendimento = rsp.data[0].nomeLocal
            this.servicosRetornadosOrdenados = rsp.data
            this.gerarCodigoNaMaquina2()
            this.servicosRecebidos.forEach(elementRecebido => {
              elementRecebido.color = ''
            })
            this.prioridade = false
            this.servicos = []
            this.montarInterface()
            this.desabilitaBotaoGerarFicha = false
          })
          .catch(err => {
            console.log('catch..')
            this.desabilitaBotaoGerarFicha = false
            console.log(err)
          })
      } else {
        this.erroServicos = 'Os exames selecionados não possuem serviços correspondentes cadastrado na unidade.'
        setTimeout(() => {
          this.erroServicos = ''
        }, 5000)
      }
    },

    converterMes (mes) {
      var month = []
      month[0] = 'janeiro'
      month[1] = 'fevereiro'
      month[2] = 'março'
      month[3] = 'abril'
      month[4] = 'maio'
      month[5] = 'junho'
      month[6] = 'julho'
      month[7] = 'agosto'
      month[8] = 'setembro'
      month[9] = 'outubro'
      month[10] = 'novembro'
      month[11] = 'dezembro'

      return month[mes]
    },

    deleteItem (item) {
      console.log(item)
      var editedIndex = this.solicitacoesExames.indexOf(item)
      // console.log(editedIndex)
      this.indexExame = editedIndex
      this.isDelete = true
    },
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    consultarOrcamentoExames () {
      var exames = []
      this.loadMoney = true
      var orcamentoExames = 0
      for (let i = 0; i < this.solicitacoesExames.length; i++) {
        const e = this.solicitacoesExames[i]
        exames.push(e.idExame)
      }
      posAtendimentoService.consultarOrcamento({
        idEmpresa: 11,
        exames: exames
      }).then(r => {
        if (r.status == 200) {
          console.log(r.data)
          if (exames.length != r.data.length) {
            this.alertOrcamento = true
          } else {
            this.alertOrcamento = false
          }
          for (let i = 0; i < r.data.length; i++) {
            const e = r.data[i]
            // console.log('Solicitacão: ' ,solicitacoesExames)
            for (let j = 0; j < this.solicitacoesExames.length; j++) {
              const ex = this.solicitacoesExames[j]
              if (e.id == ex.idExame) {
                orcamentoExames = orcamentoExames + e.valor
                ex.valor = e.valor
              }
            }
          }
          this.orcamentoExames = orcamentoExames.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }
      }).finally(() => {
        this.loadMoney = false
      })
    }
  },
  watch: {
    solicitacoesExames (val) {
      this.consultarOrcamentoExames()
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    console.log('mounted user', this.user)
    if (this.user.idEmpresa == 4) {
      this.idUnidadeNegocio = 981
    } else if (this.user.idEmpresa == 11) {
      this.idUnidadeNegocio = 295
    } else if (this.user.idEmpresa == 9) {
      this.idUnidadeNegocio = 133
    }
    this.retornarServicos()
  }
}
</script>
